import React from 'react';
import PropTypes from 'prop-types';

export default function ExperimentVariant({
  id,
  activeVariant,
  children,
}) {
  const ids = Array.isArray(id) ? id : [id];
  const includesOriginal = ids.includes('0');
  const includesActiveVariant = ids.includes(activeVariant);
  const shouldRenderContent = includesActiveVariant && !includesOriginal;

  return (
    <>
      {shouldRenderContent ? children : null}
    </>
  );
}

ExperimentVariant.propTypes = {
  activeVariant: PropTypes.string,
  children: PropTypes.node,
  id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]).isRequired,
};

ExperimentVariant.defaultProps = {
  activeVariant: '0',
  children: null,
};
